import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useTheme } from "@mui/material";
import { Stack } from "@mui/material";

import { Box } from "@/Components/v2/atoms/Box";
import { Tooltip } from "@/Components/v2/atoms/ToolTip";
import { Typography } from "@/Components/v2/atoms/Typography";

export interface TypographyWithInfoTooltipProps {
  label: string;
  infoTitle: string;
  infoText: string;
  placement?: "top" | "bottom" | "left" | "right";
}

export const TypographyWithInfoTooltip: React.FC<TypographyWithInfoTooltipProps> = ({
  label,
  infoTitle,
  infoText,
  placement = "bottom",
  ...props
}) => {
  const theme = useTheme();

  const tooltipContent = (
    <Box sx={{ p: 1.5 }}>
      <Typography
        fontSize={16}
        fontWeight={600}
        marginBottom={1}
        sx={{ color: theme.palette.common.white }}
      >
        {infoTitle}
      </Typography>
      <Typography variant="body1" fontSize={14} sx={{ color: theme.palette.common.white }}>
        {infoText}
      </Typography>
    </Box>
  );

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography variant="body1" fontWeight={600}>
        {label}
      </Typography>
      {infoTitle && infoText && (
        <Tooltip title={tooltipContent} placement={placement} {...props}>
          <InfoOutlinedIcon
            fontSize="small"
            sx={{
              color: theme.palette.brandedTypography.textColor,
            }}
          />
        </Tooltip>
      )}
    </Stack>
  );
};

export default TypographyWithInfoTooltip;
